import { useEffect, useRef } from 'react'

const onHeightChange = () => {
    // Force redraw

    setTimeout(() => {
        window.scrollTo(0, 0)
    }, 10)
}

export default function useIOSKeyboardFix(threshold = 100) {
    const lastHeightRef = useRef()

    useEffect(() => {
        if (typeof window === 'undefined') return

        lastHeightRef.current = window.innerHeight

        const checkHeightChange = () => {
            const currentHeight = window.innerHeight
            const lastHeight = lastHeightRef.current

            // Only trigger if the height is greater than the threshold

            if (Math.abs(currentHeight - lastHeight) >= threshold) {
                lastHeightRef.current = currentHeight

                if (currentHeight > lastHeight) {
                    onHeightChange(currentHeight)
                }
            }
        }

        const intervalId = window.setInterval(checkHeightChange, 300)

        return () => {
            clearInterval(intervalId)
        }
    }, [onHeightChange, threshold])
}
